import React, { useMemo, useState } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { Button } from 'primereact/button'
import { routes } from '../../constants'
import storage from '../../services/stoage.service'
import { messageActions } from '../../store/message'
import { AgendarRelatorioDialog } from './AgendarRelatorioDialog'
import { FiltrosSalvosRelatorio } from './FiltrosSalvosRelatorio'
import { podeAgendar } from './agendamentoRelatorio.utils'
import { aplicarPreparado } from './padraoNaTela'
import { getRelatorioAgendavel } from './relatoriosAgendaveis'
import { textoAgendamento } from './textos'

const mapDispatchToProps = (dispatch) => ({
  mostrarSucesso: (mensagem) => dispatch(messageActions.showMessages([mensagem], 'success')),
})

/**
 * Botao "Agendar" das telas fixas de relatorio, com o dialogo de agendamento, e os botoes do filtro salvo
 * (PHOENIX-107: "Salvar" e "Filtros salvos"). Vai ao lado do "Visualizar" da tela. O Agendar nao aparece para quem
 * nao acessa "Relatorios agendados"; o filtro salvo aparece para todos. Nada aparece para path sem cadastro em
 * relatoriosAgendaveis.
 *
 * Props:
 * - path: o relatorio em relatoriosAgendaveis (e em TelasFixasAgendaveis, no back), ex.: 'falecidos'
 * - record: o registro da tela; os filtros do agendamento saem dele, como no "Visualizar"
 * - setField(campo, valor), onChangeUnit(evento): os da tela, para abrir preenchida com o filtro padrao (PHOENIX-107,
 *   fase 3). Sem o setField a tela nao abre com o padrao; o onChangeUnit so e chamado quando o padrao traz o campo
 *   'unidade' (a tela de tipos de sepultura usa outro)
 * - aoAplicarPadrao(extras) (opcional): o que do padrao fica fora do record da tela (ex.: estadoConspaga)
 */
const AgendarTelaFixaBase = ({ path, record, setField, onChangeUnit, aoAplicarPadrao, mostrarSucesso }) => {
  const [visivel, setVisivel] = useState(false)
  const pode = useMemo(() => podeAgendar(storage.getMenus(), routes.PATH_AGENDAMENTOS_RELATORIO), [])
  const agendavel = useMemo(() => getRelatorioAgendavel(path), [path])
  if (!agendavel || !agendavel.filtrosDaTela) {
    return null
  }
  const relatorio = { path, descricao: agendavel.descricao }
  const aplicarPadrao =
    agendavel.prepararPadrao && setField
      ? (filtros, vigente) =>
          agendavel.prepararPadrao(filtros).then((preparado) =>
            aplicarPreparado(preparado, vigente, ({ record: doPadrao, extras }) => {
              // a unidade primeiro, pelo onChangeUnit da tela: as cargas que dependem dela (tipos de sepultura, contas,
              // grupos financeiros) seguem a unidade do padrao. Antes dos tipos: a carga de tipos das telas tira do
              // registro de agora os tipos que nao reconhece (compara por 'value', e o registro os tem em 'label')
              if (doPadrao.unidade && onChangeUnit) {
                onChangeUnit({ target: { name: 'unidade', value: doPadrao.unidade } })
              }
              Object.keys(doPadrao).forEach((campo) => {
                if (campo !== 'unidade' || !onChangeUnit) {
                  setField(campo, doPadrao[campo])
                }
              })
              if (extras && aoAplicarPadrao) {
                aoAplicarPadrao(extras)
              }
            })
          )
      : undefined
  return (
    <React.Fragment>
      {pode && (
        <React.Fragment>
          <Button
            label={textoAgendamento('agendar')}
            icon="pi pi-clock"
            className="p-button-secondary"
            style={{ marginLeft: '.25em' }}
            onClick={() => setVisivel(true)}
          />
          {/* fora da barra de botoes da tela: o dialogo e montado no body */}
          {ReactDOM.createPortal(
            <AgendarRelatorioDialog
              visible={visivel}
              onHide={() => setVisivel(false)}
              relatorio={relatorio}
              camposData={agendavel.camposData}
              EditorFiltros={agendavel.EditorFiltros}
              filtrosTela={agendavel.filtrosDaTela(record)}
              onSaved={() => mostrarSucesso(textoAgendamento('agendado'))}
            />,
            document.body
          )}
        </React.Fragment>
      )}
      <FiltrosSalvosRelatorio
        relatorio={relatorio}
        camposData={agendavel.camposData}
        EditorFiltros={agendavel.EditorFiltros}
        filtrosDaTela={() => agendavel.filtrosDaTela(record)}
        aplicarPadrao={aplicarPadrao}
      />
    </React.Fragment>
  )
}

export const AgendarTelaFixa = connect(null, mapDispatchToProps)(AgendarTelaFixaBase)
